module.exports = __webpack_public_path__ + "static/fonts/GodoB.4fabe77.woff";